import React from "react";
import "./bottomheader.css";
import { Container } from "react-bootstrap";
import logo from "../../assets/Pasted image.png";
import { FaSearch, FaShoppingCart } from "react-icons/fa";
import { Link } from "react-router-dom";

const BottomHeader = () => {
  return (
    <div className="body-bottomheader">
      <Container>
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid align-items-center d-flex justify-content-between p-0">
            <a className="navbar-brand d-flex align-items-center" href="/">
              <img src={logo} alt="Logo" className="logo" data-aos="zoom-in" />
              <span className="brand-name">EHSAS</span>
            </a>

            <button
              className="navbar-toggler border-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse justify-content-center"
              id="navbarNav"
            >
              <ul
                className="navbar-nav d-flex flex-row justify-content-center align-items-center p-0 m-0 fw-medium"
                style={{ columnGap: "70px" }}
              >
                <Link to="/" style={{ textDecoration: "none" }}>
                  <li className="nav-item">
                    <a className="nav-link">Home</a>
                  </li>
                </Link>
                <li className="nav-item">
                  <a href="#about" className="nav-link">
                    About
                  </a>
                </li>
                {/* <li className="nav-item">
                  <a href="#features" className="nav-link">
                    Features
                  </a>
                </li> */}
                <li className="nav-item">
                  <a href="#services" className="nav-link">
                    Services
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#contact" className="nav-link">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </Container>
    </div>
  );
};

export default BottomHeader;
